<template>
  <p>
    <template v-for="line in splitContent(data.content)">
      <template v-if="line.segments">
        <FormattedContent :data="segment" v-for="segment in line.segments">{{ $t(segment.content) }}</FormattedContent>
      </template>
      <template v-else>
        <FormattedContent :data="data">{{ $t(line) }}</FormattedContent>
      </template>
      <br>
    </template>
  </p>
</template>
<script>
import dynamicLocalization from '../../../mixins/dynamic-localization';
import FormattedContent from './FormattedContent.vue';

export default {
  components: { FormattedContent },
  mixins: [dynamicLocalization],
  props: ["data"],
  methods: {
    splitContent(content) {
      return Array.isArray(content) ? content : [content]
    },
  }
}
</script>
